import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { throwApiError } from "./apiError";

/**
 * POST API call using Axios
 */

type LogParams = { errorMessage: string; error?: unknown };

const DEFAULT_LOG_PARAMS: LogParams = { errorMessage: "" };

export const Log = async (params?: LogParams) => {
  try {
    const response = await axios.post(
      getUrl(ApiType.LOGGLY_LOG),
      params ?? DEFAULT_LOG_PARAMS
    );
    return response.data;
  } catch (error: any) {
    throwApiError(error, ErrorMessages.logglyLogAPIError, { badRequestOrder: "errorsFirst" });
  }
};
